import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboardCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M20.9071 6.125C23.6715 6.125 25.9131 8.36664 25.9131 11.1311V22.9944C25.9131 25.7588 23.6715 28.0005 20.9071 28.0005H11.0946C8.33019 28.0005 6.08855 25.7588 6.08855 22.9944V11.1311C6.08855 8.36664 8.33019 6.125 11.0946 6.125M12.0547 17.7881L14.644 20.3773L19.9432 15.0781M19.0977 8.38081H12.9021C11.9032 8.38081 11.0937 7.57132 11.0937 6.57244V5.80836C11.0937 4.80948 11.9032 4 12.9021 4H19.0977C20.0967 4 20.9061 4.80948 20.9061 5.80836V6.57244C20.9061 7.57132 20.0967 8.38081 19.0977 8.38081Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClipboardCheck;
